import React, {
	useEffect
}from 'react'
import {
	Form
}from 'antd'
import {
	reReasonActions
}from '../ReReasonTypes/actions'
import {
	useDispatch,
	useSelector
}from 'react-redux'
import NRISelect from "../NSISelector/NRISelect"

const i18n = {
	selectItems: {
		1 : ['Причина повторного обращения'],
		0 : ['Прычына паўторнага звароту']
	},
	placeholderItems: {
		1 : ['Начните вводить название'],
		0 : ['Пачніце ўводзіць назву']
	},
	isRequired: {
		1 : "Поле обязательно для заполнения.",
		0 : "Поле абавязкова для запаўнення."
	}
}

export const SelectReasonType = (props) => {
	const { form, isRequired = true } = props
	const ReasonTypes = useSelector(state => state.reReasonTypesReducer.currentItem)
	const dispatch = useDispatch()
	const isRu = useSelector(state => state.globalReducer.isRu)

	const getReasonByName = params => {
		dispatch(reReasonActions.getReasonByName(params))
	}

	const pageSize = 10

	useEffect(() => {
		getReasonByName({
			page     : 1,
			pageSize : pageSize,
			name     : ''
		})
	}, [])
	return (
		<>
			<Form.Item
				label={ i18n.selectItems[isRu][0] }
				name="ReasonType"
				rules={ [
					{
						required : isRequired && true,
						message  : i18n.isRequired[isRu]
					}
				] }
			>
				<NRISelect
					multiple
					actions={ reReasonActions }
					actionType="getReasonByName"
					filterOption={ (input, option) => option.title.toLowerCase().includes(input.toLowerCase())} 
					placeHolder={ i18n.placeholderItems[isRu][0] }
					reducer="reReasonTypesReducer"
					value={ form.getFieldValue("ReasonType") }
					onChange={ (val) => {
						form.setFieldsValue({ ReasonType: val?.map(r => r.id)  })
					} }
					
				/>
			</Form.Item>
		</>
	)
}

export default SelectReasonType